import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

/** Merge von Tailwind-Klassen (Konflikte werden zugunsten der letzten Klasse aufgelöst). */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
